fx.ns("models", class ProductPosterPage extends  models.CreationElement {

	constructor(data)
	{
		super(data);
	}

     getBackground(side)
     {
        let bg = super.getBackground();
        if (!bg)
        {
            this.components.addItemAt(0,new models.CreationElementContent({creation_element_id : this.id, creation:"", component_type:"background", bgcolor : this.bgcolorleft, align: ""}));
            bg = super.getBackground();
        }

        return bg;
     }
	
});
